var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachmentGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.6199 7.80152L7.05794 15.7281C6.92298 16.0285 6.93936 16.382 7.10349 16.711C7.26761 17.04 7.56603 17.3175 7.93309 17.4824C8.30016 17.6474 8.7058 17.6863 9.06078 17.5906C9.41576 17.4948 9.691 17.2723 9.82596 16.972L14.4057 6.78064C14.6756 6.17999 14.6428 5.4729 14.3146 4.8149C13.9863 4.15691 13.3895 3.60192 12.6554 3.27202C11.9212 2.94213 11.1099 2.86435 10.4 3.0558C9.69002 3.24726 9.13953 3.69225 8.86962 4.2929L4.28991 14.4843C3.88504 15.3852 3.9342 16.4459 4.42657 17.4329C4.91894 18.4199 5.81419 19.2524 6.91538 19.7472C8.01657 20.242 9.23349 20.3587 10.2984 20.0715C11.3634 19.7844 12.1891 19.1169 12.594 18.2159L16.156 10.2893",
    stroke: "#4D4D4D",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentGrey);
export default __webpack_public_path__ + "static/media/attachment_grey.b58177e05839c8800298f8d3d2d164b0.svg";
export { ForwardRef as ReactComponent };